import { render, staticRenderFns } from "./PlantProtocolData.vue?vue&type=template&id=290e27f4&"
import script from "./PlantProtocolData.vue?vue&type=script&lang=ts&"
export * from "./PlantProtocolData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports